import { render, staticRenderFns } from "./table73.vue?vue&type=template&id=0fd0dbbc&scoped=true"
import script from "./table73.vue?vue&type=script&lang=js"
export * from "./table73.vue?vue&type=script&lang=js"
import style0 from "./table73.vue?vue&type=style&index=0&id=0fd0dbbc&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd0dbbc",
  null
  
)

export default component.exports